import {
  isRequired,
  isValidUploadedImageSize,
  isValidUploadedImageFormat,
  isNumber
} from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.coverPhoto) {
    if (isRequired(values.coverPhoto.image || '', true)) {
      errors.coverPhoto = 'Cover photo is required';
    } else if (isValidUploadedImageSize(values.coverPhoto || '', true)) {
      errors.coverPhoto = 'Your file exceeded the size limit';
    } else if (isValidUploadedImageFormat(values.coverPhoto || '', true)) {
      errors.coverPhoto = `File could not be uploaded because the format is not supported. 
          Please upload the file with the format: png, jpg, jpeg`;
    }
  } else {
    errors.coverPhoto = 'Cover photo is required';
  }

  if (isRequired(values.title || '', true)) {
    errors.title = 'Title is required';
  }

 if (isNumber(values.availableUnits || '', true)) {    
    errors.availableUnits = 'Available units is required';
  } else if (isNumber(values.availableUnits)) {
    errors.availableUnits = 'Must be a number';
  } else if (values.availableUnits < 0) {
    errors.availableUnits = 'Cannot be negative';
  }


   if (isNumber(values.status || '', true)) {
    errors.status = 'Status is required';
  }

  if (isNumber(values.itemType || '', true)) {
    errors.itemType = 'Item type is required';
  }

  if(isNumber(values.minDays || '', true)){
    errors.minDays = "Min Days are required "
  }

  if(isNumber(values.maxDays || '', true)){
    errors.maxDays = "Max Days are required "
  }

  return errors;
};

export default validate;
